module.exports = __webpack_public_path__ + "static/second-splash-extended-0718aeb8c84ab1347316f1f63d69a971.jpg";